import { Box, Drawer, List, Toolbar } from '@mui/material';
import { AppConfig } from '../../app/AppConfig';
import { SideBarList } from './SideBarList';

const SidebarDrawer = ({ openNavigation, menuOpen }) => {
  return (
    <>
      <Drawer
        sx={{
          width: AppConfig.sideBarWidth,
          [`& .MuiDrawer-paper`]: {
            width: AppConfig.sideBarWidth,
            boxSizing: 'border-box',
            overflow: 'hidden',
            // height: 'calc(100% - 64px)', marginTop: '64px'
          },
          display: { xs: 'none', md: 'block' },
        }}
        variant={'permanent'}
      >
        <Toolbar />
        <Box
          className={'scrollBarCont'}
          sx={{
            overflow: 'auto',
          }}
        >
          <List>
            <SideBarList />
          </List>
        </Box>
      </Drawer>
      <Drawer
        variant={'temporary'}
        open={menuOpen}
        onClose={openNavigation}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <Box
          className={'scrollBarCont'}
          sx={{
            overflow: 'auto',
          }}
        >
          <List>
            <SideBarList />
          </List>
        </Box>
      </Drawer>
    </>
  );
};

SidebarDrawer.propTypes = {};

SidebarDrawer.defaultProps = {};

export { SidebarDrawer };
